import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ace269d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-view" }
const _hoisted_2 = { class: "chat-header" }
const _hoisted_3 = {
  class: "chat-items",
  ref: "chatItemEl"
}
const _hoisted_4 = { class: "chat-input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-send" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatBubble = _resolveComponent("ChatBubble")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatItems, (item, index) => {
        return (_openBlock(), _createBlock(_component_ChatBubble, {
          onClick: ($event: any) => (_ctx.onClick(item)),
          key: index,
          item: item,
          "is-last": index === _ctx.chatItems.length - 1,
          active: _ctx.isActive(item)
        }, null, 8, ["onClick", "item", "is-last", "active"]))
      }), 128)),
      (_ctx.typing)
        ? (_openBlock(), _createBlock(_component_ChatBubble, {
            key: 0,
            item: _ctx.typingMessage
          }, null, 8, ["item"]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("form", {
      ref: "chatForm",
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ion_textarea, {
          ref: "chatInput",
          "auto-grow": "",
          rows: "1",
          minlength: "1",
          maxlength: "2048",
          autocapitalize: "on",
          autocorrect: "on",
          autocomplete: "on",
          type: "text",
          value: _ctx.value,
          onKeypress: _withKeys(_withModifiers(_ctx.send, ["prevent"]), ["enter"]),
          onIonChange: _ctx.onChange
        }, null, 8, ["value", "onKeypress", "onIonChange"]),
        _createVNode(_component_ion_fab_button, {
          onClick: _ctx.send,
          disabled: !_ctx.canSend,
          type: "submit",
          size: "small",
          class: "chat-input-send-btn"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ], 544)
  ]))
}